import React from 'react';
import {
  ShareIcon,
  ClipboardDocumentIcon,
  ArrowTopRightOnSquareIcon
} from '@heroicons/react/24/outline';

const ShareButtons = ({ title, slug }) => {
  // Construire l'URL de partage vers ton backend /share/:slug
  const baseShareUrl = 'https://xibarubamback.onrender.com/share'; // <-- mets ici l'URL de ton backend
  const shareUrl = `${baseShareUrl}/${encodeURIComponent(slug)}`;

  const encodedUrl = encodeURIComponent(shareUrl);
  const encodedTitle = encodeURIComponent(title);

  const copyUrl = () => {
    navigator.clipboard.writeText(shareUrl).then(() => {
      alert('URL copiée dans le presse-papier !');
    });
  };

  return (
    <div className="flex space-x-4 items-center">

      {/* Copier l'URL */}
      {/* <button
        onClick={copyUrl}
        title="Copier l'URL"
        className="text-gray-600 hover:text-blue-500 transition"
      >
        <ClipboardDocumentIcon className="h-6 w-6" />
      </button> */}

      {/* Partage Facebook */}
      {/* <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        title="Partager sur Facebook"
        className="text-gray-600 hover:text-blue-600 transition"
      >
        <ShareIcon className="h-6 w-6" />
      </a> */}

      {/* Partage Twitter */}
      {/* <a
        href={`https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`}
        target="_blank"
        rel="noopener noreferrer"
        title="Partager sur Twitter"
        className="text-gray-600 hover:text-blue-400 transition"
      >
        <ArrowTopRightOnSquareIcon className="h-6 w-6" />
      </a> */}
    </div>
  );
};

export default ShareButtons;
